module.exports = __webpack_public_path__ + "static/media/p5.77d9976f.webp";